import { useCallback, useState } from 'react';

const defaultActionState = { type: 'NONE', data: {} };

export const useActionState = () => {
  const [actionState, setActionState] = useState(defaultActionState);

  const setCurrentActionState = useCallback(
    ({ type, data = {} }) => {
      setActionState({ type, data });
    },
    [setActionState]
  );

  const resetActionState = useCallback(() => {
    setActionState(defaultActionState);
  }, [setActionState]);

  return { actionState, setCurrentActionState, resetActionState };
};
